const DEFAULT_LABELS = {
  berth: "Berth",
  zone: "Operational zone",
  no_go: "No-go area",
  route: "Access route",
  emergency_route: "Emergency route",
  navigation_area: "Navigation area",
  navigation_hazard: "Navigation hazard",
};

const titleCase = (value) => String(value || "map_item")
  .replaceAll("_", " ")
  .replace(/\b\w/g, character => character.toUpperCase());

export function buildAnnotationLegend(annotations, colors = {}) {
  const grouped = new Map();
  (annotations || []).forEach(annotation => {
    const key = annotation.feature_type || annotation.type || "map_item";
    const existing = grouped.get(key) || {
      key,
      label: DEFAULT_LABELS[key] || titleCase(key),
      color: annotation.color || colors[annotation.type] || "#64748B",
      count: 0,
      proposed: 0,
    };
    existing.count += 1;
    if (annotation.status === "proposed") existing.proposed += 1;
    grouped.set(key, existing);
  });
  return [...grouped.values()].sort((left, right) => left.label.localeCompare(right.label));
}
